// extracted by mini-css-extract-plugin
export default {"assessmentScoresContainer":"styles_assessmentScoresContainer__EFq5n","sections":"styles_sections__hVBuu","expertsSection":"styles_expertsSection__R2cYb"};